import { Footer } from "../../../features/footer/footer";
import { JobList } from "../../../features/jobList/jobList";


export function JobListPage() {

    return (
        <div>
            <JobList />
            <Footer />
        </div>
    );
}